import React from 'react';

import { defineMessage, IntlProvider, useIntl } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import { DropdownTrigger } from '@atlassian/entry-points/dropdown-trigger';

import { loadingDropdownEntryPoint } from '../fixtures/constellation/loading-dropdown-entry-point';
import { RelayWrapper } from '../utils/wrapper';

const triggerLabel = defineMessage({
	id: 'entry-points.examples.dropdown.trigger.ai-non-final',
	defaultMessage: 'Page actions',
	description: 'Label on the example button that opens a menu of actions for the current page.',
});
const menuLabel = defineMessage({
	id: 'entry-points.examples.dropdown.label.ai-non-final',
	defaultMessage: 'Actions for this page',
	description: 'Accessible name of the example dropdown menu, including while its actions load.',
});
const loadingMessage = defineMessage({
	id: 'entry-points.examples.dropdown.loading.ai-non-final',
	defaultMessage: 'Loading page actions',
	description:
		'Message displayed while the example dropdown is waiting for its menu items to load.',
});

const frenchMessages = {
	[triggerLabel.id]: 'Actions de la page',
	[menuLabel.id]: 'Actions pour cette page',
	[loadingMessage.id]: 'Chargement des actions de la page',
};

function TranslatedDropdown(): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<DropdownTrigger
			entryPoint={loadingDropdownEntryPoint}
			trigger={formatMessage(triggerLabel)}
			menuLabel={formatMessage(menuLabel)}
			loadingText={formatMessage(loadingMessage)}
			shouldRenderToParent
		/>
	);
}

export default function DropdownTriggerInternationalization(): React.JSX.Element {
	return (
		<IntlProvider locale="fr" defaultLocale="en" messages={frenchMessages}>
			<RelayWrapper>
				<Box lang="fr">
					<TranslatedDropdown />
				</Box>
			</RelayWrapper>
		</IntlProvider>
	);
}
